var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"observe-trend"},[_c('total-add'),_c('every-satellite')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }